import React, { useState, useEffect } from "react";
import { useCompanyContext } from "../hooks/useCompanyContext";
import { useCultivationCompanyContext } from "../hooks/useCultivationCompanyContext"; // Import context
import ApprovalModal from "../components/ApprovalModal";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import "./Ordergoedkeuren.css"

const OrderGoedkeuren = () => {
  const { company } = useCompanyContext();
  const { t } = useCompanyContext();
  const { cultivationCompany } = useCultivationCompanyContext(); // Haal het bedrijf op
  const { user } = useAuthContext();

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

    // Demo: 1 order tonen als "1/2"
  // Zet dit in je browser console (op de demo machine):
  // localStorage.setItem("demo_four_eyes_half_approved_order", "ORDERNO_HIER");
  const demoHalfApprovedOrderNo =
    localStorage.getItem("demo_four_eyes_half_approved_order") || "";

  const navigate = useNavigate();
  const { dispatch } = useAuthContext();

  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const filtered = company?.orders?.filter(
      (o) => o.IA_StatusCode === "ACCORDERENKLANT"
    ) || [];

    setOrders(filtered);
  }, [company?.orders]);

  const fetchOrderDetails = async (orderNo) => {
    if (!cultivationCompany || !cultivationCompany.name) {
      alert("Geen geldig bedrijf geselecteerd.");
      return;
    }

    setIsLoadingPdf(true); // Zet laden op true
    try {
      const orderResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/pdf/${orderNo}`, {
        responseType: "blob", // Ontvang als blob
        headers: {
          "X-Cultivation-Company": cultivationCompany.name, // Stuur alleen de naam mee
        },
      });
  
      const orderPdfUrl = window.URL.createObjectURL(orderResponse.data); // Maak blob-URL aan
      const termsPdfUrl1 = "/alg_vw_Plantum.pdf"; // Voorwaarden PDF in public-map
      const termsPdfUrl2 = "/WPK-Aanvullende_voorwaarden_NL_1.pdf"; // Voorwaarden PDF in public-map

      setSelectedOrder({
        no: orderNo,
        orderPdf: orderPdfUrl,
        termsPdf1: termsPdfUrl1,
        termsPdf2: termsPdfUrl2,
      });

      setModalOpen(true);
    } catch (error) {
      console.error("Fout bij ophalen van orderdetails:", error);
      alert("Kon de orderdetails niet ophalen.");
    } finally {
      setIsLoadingPdf(false); // Zet laden op false
    }
  };

  const handleApprove = async (orderNo) => {
    if (!cultivationCompany || !cultivationCompany.name) {
      alert("Geen geldig bedrijf geselecteerd.");
      return;
    }

    // 🔑 Hier halen we je user + token uit localStorage
    const savedUser = localStorage.getItem("user");
    const parsedUser = savedUser ? JSON.parse(savedUser) : null;
    const token = parsedUser?.token;

    if (!token) {
      alert("Je bent niet (meer) ingelogd. Log opnieuw in en probeer het nog eens.");
      dispatch({ type: "LOGOUT" });
      navigate("/login");
      return;
    }

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/orders/approve/${orderNo}`, null, {
        headers: {
          "X-Cultivation-Company": cultivationCompany.name, // Stuur alleen de naam mee
          Authorization: `Bearer ${token}`,
        },
      });

      // 🟡 DEMO order?
      if (res.data?.demo) {
        alert(res.data.message || "DEMO order");
        return; // ⛔ niks verder doen
      }

      setOrders((prev) => prev.filter((o) => o.No !== orderNo));

      alert(`Order ${orderNo} is goedgekeurd.`);
    } catch (error) {
      console.error("Fout bij goedkeuren van de order:", error?.response || error);

      const msg = error?.response?.data?.error;
  
      if (msg === "Token expired") {
        alert("Uw sessie is verlopen. Log alstublieft opnieuw in.");
  
        // Ruim alles netjes op via AuthContext
        dispatch({ type: "LOGOUT" });
  
        navigate("/login");
        return;
      }
  
      alert(
        msg || "Er is een fout opgetreden bij het goedkeuren van de order."
      );
    }
  };

  const handleCloseModal = () => {
    if (selectedOrder?.orderPdf) {
      window.URL.revokeObjectURL(selectedOrder.orderPdf); // Cleanup orderPdf
    }
    if (selectedOrder?.termsPdf1) {
      window.URL.revokeObjectURL(selectedOrder.termsPdf1); // Cleanup termsPdf
    }
    if (selectedOrder?.termsPdf2) {
      window.URL.revokeObjectURL(selectedOrder.termsPdf2); // Cleanup termsPdf2
    }
    setModalOpen(false); // Sluit de modal
    setSelectedOrder(null); // Reset de geselecteerde order
  };

  return (
    <div className="order-table">
      <h3 className="pageheading">{t.ordersGoedkeuren}</h3>
      <table>
        <thead>
          <tr>
            <th>{t.ordernummer}</th>
            <th>{t.leverdatum}</th>
            <th>{t.verzendnaam}</th>
            <th>{t.status}</th>
            <th>{t.actie}</th>
          </tr>
        </thead>
        <tbody>
          {orders?.map((order) => (
            <tr key={order.No}>
              <td>{order.No}</td>
              <td>
                {order.IA_PromisedDeliveryDate
                  ? new Date(order.IA_PromisedDeliveryDate).toLocaleDateString("nl-NL", { day: "2-digit", month: "2-digit", year: "numeric", })
                  : "N.v.t."}
              </td>
              <td>
                {order.Ship_to_Name}
              </td>
              <td>{order.IA_StatusCode}</td>
              <td>
                <button
                  onClick={() => fetchOrderDetails(order.No)}
                  className="approve-button"
                  disabled={isLoadingPdf} // Knop uitschakelen tijdens laden
                >
                  {isLoadingPdf ? "Laden..." : t.orderGoedkeuren}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      {Array.isArray(user?.roles) && user.roles.includes("actorius") && (
      <>  
      <h3 className="pageheading">Orders goedkeuren NIEUW</h3>
      <table>
        <thead>
            <tr>
              <th>{t.ordernummer}</th>
              <th>{t.leverdatum}</th>
              <th>{t.verzendnaam}</th>
              <th>{t.status}</th>
              <th>Accorderen</th>
              <th>{t.actie}</th>
            </tr>
          </thead>
        <tbody>
        {orders?.map((order) => {
            const progress = String(order.No) === String(demoHalfApprovedOrderNo) ? "1/2" : "1/2";

            return (
              <tr key={order.No}>
                <td>{order.No}</td>
                <td>
                  {order.IA_PromisedDeliveryDate
                    ? new Date(order.IA_PromisedDeliveryDate).toLocaleDateString("nl-NL", { day: "2-digit", month: "2-digit", year: "numeric", })
                    : "N.v.t."}
                </td>
                <td>
                {order.Ship_to_Name}
              </td>
                <td>{order.IA_StatusCode}</td>

                <td>
                  <span className={`approval-progress ${progress === "1/2" ? "is-half" : "is-half"}`}>
                    {progress}
                  </span>
                </td>

                <td>
                  <button
                    onClick={() => fetchOrderDetails(order.No)}
                    className="approve-button"
                    disabled={isLoadingPdf}
                  >
                    {isLoadingPdf ? "Laden..." : t.orderGoedkeuren}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </>
        )}
      <ApprovalModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        order={selectedOrder}
        onApprove={handleApprove}
      />
    </div>
  );
};

export default OrderGoedkeuren;
